import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import { getVodList } from "../../api/api";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useHistory } from "react-router";
import { cdnImageUrl } from "../../static/config";
import VodItem from "../vodItem";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";

const settings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 4.5,
  slidesToScroll: 4.5,
  arrows: false,
  draggable: false
};

const Carousel = ({ title, carouselId }) => {
  const [items, setItems] = useState([]);
  const sliderRef = useRef(null);

  const getBannerItems = async (id) => {
    const { data } = await getVodList(id);
    if (data?.items?.length) {
      setItems(data.items);
    }
  };

  const renderedItems = items.map((item) => {
    return <VodItem item={item} />;
  });

  useEffect(() => {
    if (carouselId) {
      getBannerItems(carouselId);
    }
  }, [carouselId]);

  return (
    <div className="carousel-wrapper">
      <div className="title">{title}</div>
      <div className="slider-wrapper">
        <Slider ref={sliderRef} {...settings}>
          {renderedItems}
        </Slider>
        {renderedItems.length > 4 ? (
          <div>
            <div
              className="arrow prev"
              onClick={() => sliderRef.current.slickPrev()}
            >
              <FontAwesomeIcon
                icon={faChevronLeft}
                style={{ fontSize: "25px" }}
                color={"black"}
              />
            </div>
            <div
              className="arrow next"
              onClick={() => sliderRef.current.slickNext()}
            >
              <FontAwesomeIcon
                icon={faChevronRight}
                style={{ fontSize: "25px" }}
                color={"black"}
              />
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Carousel;
